module.exports = __webpack_public_path__ + "img/point.4f9c47c5.svg";